import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProfilePage } from "@/components/profile";

export const Route = createFileRoute("/profile")({
  // Require auth (spec §15.9). isLoading guard avoids redirecting during
  // the AuthProvider's initial bootstrap.
  beforeLoad: ({ context }) => {
    if (!context.auth.isLoading && !context.auth.isAuthenticated) {
      throw redirect({ to: "/login", search: { redirect: "/profile" } });
    }
  },
  component: ProfilePage,
});
